import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

// import MyAlertBanner from "./components/alertbanner";
import MyNavbar from "./components/navbar";
import MyFooter from "./components/footer";

import About from "./pages/about";
import Album from "./pages/album";
import Announce from "./pages/announce";
import Articles from "./pages/articles";
import ArticleRouter from "./pages/articleRouter";
import CateractInfo from "./pages/cataract";
import Contact from "./pages/contact";
import Myopia1 from "./pages/myopia/myopia_1";
import Myopia2 from "./pages/myopia/myopia_2";
import Myopia3 from "./pages/myopia/myopia_3";
import Myopia4 from "./pages/myopia/myopia_4";
import Schedule from "./pages/schedule";
import Services from "./pages/services";
import Home from "./pages/home";
import Profile from "./pages/profile";
import Traffic from "./pages/traffic";

class App extends React.Component {
  render() {
    return (
      <>
        <Router>
          <MyNavbar />
          {/* <MyAlertBanner /> */}
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/announce" element={<Announce />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:userId" element={<ArticleRouter />} />
            <Route path="/cataract" element={<CateractInfo />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/traffic" element={<Traffic />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/services" element={<Services />} />
            <Route path="/myopia_1" element={<Myopia1 />} />
            <Route path="/myopia_2" element={<Myopia2 />} />
            <Route path="/myopia_3" element={<Myopia3 />} />
            <Route path="/myopia_4" element={<Myopia4 />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/album" element={<Album />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Router>
        <MyFooter />
      </>
    );
  }
}

export default App;
